/**
 * How large a transfer is relative to a *given set* of other transfers —
 * never a market-wide "whale" claim, and never computed from a sample too
 * small for a percentile to mean anything.
 */
export interface MagnitudeInfo {
  percentile: number;
  /** True only once the set is large enough for "top N%" to be meaningful. */
  isNotable: boolean;
}

const MIN_SAMPLE_SIZE = 5;
const NOTABLE_PERCENTILE = 90;

export function computeMagnitudes(transfers: { deltaSat: number }[]): MagnitudeInfo[] {
  if (transfers.length < MIN_SAMPLE_SIZE) {
    return transfers.map(() => ({ percentile: 0, isNotable: false }));
  }

  const sortedAbs = transfers.map((t) => Math.abs(t.deltaSat)).sort((a, b) => a - b);

  return transfers.map((t) => {
    const value = Math.abs(t.deltaSat);
    let rank = 0;
    for (const v of sortedAbs) {
      if (v <= value) rank += 1;
    }
    const percentile = Math.round((rank / sortedAbs.length) * 100);
    return { percentile, isNotable: percentile >= NOTABLE_PERCENTILE };
  });
}
